import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="mt-6">
      <p className="text-sm w-full px-4 text-gray-500">
        By continuing, you agree to our <a href="/terms" className="text-blue-400">Terms & Conditions</a> and <a href="/privacy" className="text-blue-400">Privacy Policy</a>.
      </p>
    </div>
  );
};

export default TermsAndConditions;
